export class IUserView{
  constructor(
   public AssessmentID?:any,
   public DateRaised?: any,
   public ClientName?: any,
   public ContractNumber?: any,
   public ContractName?: any,
   public AssessmentName?: any,) {}      
}